import React, { useEffect, useState } from 'react'
import { Col, Image, Row } from 'react-bootstrap'
import { useForm } from 'react-hook-form'
import CardCustom from '../../custom/card-custom'
import { BsChevronLeft } from 'react-icons/bs'
import NavTitle from '../../nav-title'
import ImgUser from '../../../images/user.png'
import {
  getTransferAPI,
  getTransferDetailAPI
} from '../../../services/transfer'
import moment from 'moment'
import { useNavigate, useSearchParams } from 'react-router-dom'
import UsePositions from '../../../hooks/use-position'
import { useSelector } from 'react-redux'
import { EMP_PVD_HISTORY } from '../../../router/routes'
import { URL_PROFILE } from '../../../Constants'

export default function TransferDetailPage() {
  const orgId = useSelector((state) => state.roleReducer.role)
  const navigate = useNavigate()
  const {
    formState: { errors }
  } = useForm({})
  let [searchParams, setSearchParams] = useSearchParams()
  const transferNo = searchParams.get('transferNo')
  const types = searchParams.get('type')
  const type = types ? types.replace(/\s/g, '') : ''
  const [data, setData] = useState([])
  const [dataDetail, setDataDetail] = useState([])
  const [dataDetailNew, setDataDetailNew] = useState([])
  const [dataDetailOld, setDataDetailOld] = useState([])

  const divisionId = dataDetailOld?.ds_id
  const departmentId = dataDetailOld?.dm_id
  const teamId = dataDetailOld?.team_id
  const positionId = dataDetailOld?.position_id

  const divisionId2 = dataDetailNew?.ds_id
  const departmentId2 = dataDetailNew?.dm_id
  const teamId2 = dataDetailNew?.team_id
  const positionId2 = dataDetailNew?.position_id

  const uuid = dataDetail.uuid
  const positions = UsePositions(orgId, divisionId, departmentId, teamId) //ตำแน่ง

  const oldPosition = positions.find((d) => d.value === positionId)

  const orgId2 = dataDetailNew?.org_id

  const positions2 = UsePositions(orgId2, divisionId2, departmentId2, teamId2) //ตำแน่ง
  const newPosition2 = positions2.find((d) => d.value === positionId2)
  useEffect(() => {
    if (uuid) {
      getTransfer()
    }
    getTransferDetail()
  }, [uuid])

  const getTransfer = async () => {
    const res = await getTransferAPI({ uuid })
    if (!res) return
    if (res.status) {
      setData(res.result)
    }
  }

  const getTransferDetail = async () => {
    const res = await getTransferDetailAPI({ transferNo })
    if (!res) return
    if (res.status) {
      setDataDetail(res.result)
      setDataDetailNew(res.result.details[0]?.news)
      setDataDetailOld(res.result.details[0]?.olds)
    }
  }

  return (
    <>
      <NavTitle>
        <div
          onClick={() => navigate(EMP_PVD_HISTORY)}
          className={`h4 text-muted my-auto text-decoration-none pointer-event`}
        >
          <BsChevronLeft /> Back
        </div>
      </NavTitle>
      <CardCustom className="p-3 h-full ">
        <Row className="border-bottom pb-3 mb-4">
          <div className="mb-3 "> {dataDetail?.transfer_type || '-'}</div>

          <Col xl={12} className="d-flex justify-content-start fw-light small">
            <div className="d-flex col-4">
              <Image
                fluid
                className="rounded-circle "
                style={{ maxWidth: 60, maxHeight: 60, objectFit: 'cover' }}
                src={`${data?.img_url}`}
                onError={(event) => {
                  event.target.src = ImgUser
                  event.onerror = null
                }}
              />
              <div className="ms-3 my-auto">
                <p
                  className="mb-2 box-text-1"
                  style={{
                    fontSize: 14
                  }}
                >
                  {' '}
                  {`${data?.title_en || '-'} ${data?.name_en || '-'} ${
                    data?.surname_en || '-'
                  }`}
                </p>
                <p
                  className="mb-0 box-text-1"
                  style={{
                    fontSize: 12
                  }}
                >
                  {' '}
                  {`${data?.title_th || '-'}${data?.name_th || '-'} ${
                    data?.surname_th || '-'
                  } (${data?.nickname_th || '-'})`}
                </p>
              </div>
            </div>
            <div className="my-auto col-4">
              <p
                className="mb-2 box-text-1"
                style={{
                  fontSize: 14
                }}
              >
                {' '}
                {`${
                  data?.start_date
                    ? moment(data.start_date).format('DD MMMM YYYY')
                    : '-'
                } ( ${data?.date_applied_job} )`}
              </p>
              <p
                className="mb-0 box-text-1"
                style={{
                  fontSize: 12
                }}
              >
                {' '}
                {`${data?.shift || '-'} (${
                  data?.start_time
                    ? moment(data.start_time, 'HH:mm:ss').format('HH:mm')
                    : '-'
                } - ${
                  data?.end_time
                    ? moment(data.end_time, 'HH:mm:ss').format('HH:mm')
                    : '-'
                }) `}
              </p>
            </div>
            <div className="my-auto col-4">
              <p
                className="mb-2 box-text-1"
                style={{
                  fontSize: 14
                }}
              >
                {' '}
                {data?.email || '-'}
              </p>
              <p
                className="mb-0 box-text-1"
                style={{
                  fontSize: 12
                }}
              >
                {' '}
                {data?.phone || '-'}
              </p>
            </div>
          </Col>
        </Row>

        {type === 'Promote' ? (
          <>
            <div className="d-flex justify-content-start col-12 p-2">
              {/* Group */}
              <div className="mb-3 row col-6">
                <div className="d-flex justify-content-start col-12">
                  <div className="col-4">
                    <p className="fw-bold small w-100">01 สายงาน</p>
                    <p className="fw-light small w-100">
                      {' '}
                      {dataDetailOld?.division_en || '-'} (
                      {dataDetailOld?.division ?? '-'})
                    </p>
                  </div>
                  <div className="d-flex justify-content-center col-2">
                    <span className="d-flex justify-content-center m-4 small fw-light">
                      to
                    </span>
                  </div>

                  <div className="col-5 d-flex justify-content-start">
                    <p className="fw-bold small w-100 text-white">.</p>
                    <p className="fw-light small w-100">
                      {' '}
                      {dataDetailNew?.division_en || '-'} (
                      {dataDetailNew?.division})
                    </p>
                  </div>
                </div>
              </div>
              {/* Department */}
              <div className="d-flex mb-3 row col-6 ">
                <div className="d-flex justify-content-start col-12">
                  <div className="col-4">
                    <p className="fw-bold small w-100">02 ฝ่าย</p>
                    <p className="fw-light small w-100">
                      {' '}
                      {/* {oldDepartment?.label || '-'} */}
                      {dataDetailOld?.department_en || '-'} (
                      {dataDetailOld?.department || '-'})
                    </p>
                  </div>
                  <div className="d-flex justify-content-center col-2">
                    <span className="d-flex justify-content-center m-4 small fw-light">
                      to
                    </span>
                  </div>

                  <div className="col-5 d-flex justify-content-start">
                    <p className="fw-bold small w-100 text-white">.</p>
                    <p className="fw-light small w-100">
                      {' '}
                      {dataDetailNew?.department_en || '-'} (
                      {dataDetailNew?.department || '-'})
                    </p>
                  </div>
                </div>
              </div>
            </div>

            <div className="d-flex justify-content-start col-12 p-2">
              {/* Faction */}
              <div className="mb-3 row col-6">
                <div className="d-flex justify-content-start col-12">
                  <div className="col-4">
                    <p className="fw-bold small w-100">03 แผนก</p>
                    <p className="fw-light small w-100">
                      {' '}
                      {dataDetailOld?.faction_en || '-'} (
                      {dataDetailOld?.faction || '-'})
                    </p>
                  </div>
                  <div className="d-flex justify-content-center col-2">
                    <span className="d-flex justify-content-center m-4 small fw-light">
                      to
                    </span>
                  </div>

                  <div className="col-5 d-flex justify-content-start">
                    <p className="fw-bold small w-100 text-white">.</p>
                    <p className="fw-light small w-100">
                      {' '}
                      {dataDetailNew?.faction_en || '-'} (
                      {dataDetailNew?.faction || '-'})
                    </p>
                  </div>
                </div>
              </div>
              {/* Team */}
              <div className="mb-3 row col-6">
                <div className="d-flex justify-content-start col-12">
                  <div className="col-4">
                    <p className="fw-bold small w-100">04 ทีม</p>
                    <p className="fw-light small w-100">
                      {' '}
                      {dataDetailOld?.team_en || '-'}
                    </p>
                  </div>
                  <div className="d-flex justify-content-center col-2">
                    <span className="d-flex justify-content-center m-4 small fw-light">
                      to
                    </span>
                  </div>

                  <div className="col-5 d-flex justify-content-start">
                    <p className="fw-bold small w-100 text-white">.</p>
                    <p className="fw-light small w-100">
                      {' '}
                      {dataDetailNew?.team_en || '-'}
                    </p>
                  </div>
                </div>
              </div>
            </div>

            <div className="d-flex justify-content-start col-12 p-2">
              {/* Position */}
              <div className="mb-3 row col-6">
                <div className="d-flex justify-content-start col-12">
                  <div className="col-4">
                    <p className="fw-bold small w-100">05 ตำแหน่ง</p>
                    <p className="fw-light small w-100">
                      {' '}
                      {oldPosition?.label || '-'}
                    </p>
                  </div>
                  <div className="d-flex justify-content-center col-2">
                    <span className="d-flex justify-content-center m-4 small fw-light">
                      to
                    </span>
                  </div>

                  <div className="col-5 d-flex justify-content-start">
                    <p className="fw-bold small w-100 text-white">.</p>
                    <p className="fw-light small w-100">
                      {' '}
                      {dataDetailNew?.position_en || '-'}
                    </p>
                  </div>
                </div>
              </div>
              {/* Level */}
              <div className="d-flex mb-3 row col-6 ">
                <div className="d-flex justify-content-start col-12">
                  <div className="col-4">
                    <p className="fw-bold small w-100">06 Level</p>
                    <p className="fw-light small w-100">
                      {oldPosition?.level_id || '-'}
                    </p>
                  </div>
                  <div className="d-flex justify-content-center col-2">
                    <span className="d-flex justify-content-center m-4 small fw-light">
                      to
                    </span>
                  </div>

                  <div className="col-5 d-flex justify-content-start">
                    <p className="fw-bold small w-100 text-white">.</p>
                    <p className="fw-light small w-100">
                      {newPosition2?.level_id || '-'}
                    </p>
                  </div>
                </div>
              </div>
            </div>

            <div className="d-flex justify-content-start col-12 p-2">
              {/* Effective Date */}
              <div className="d-flex mb-3 row col-7">
                <ColFrom>
                  <p className="mb-2 fw-bold small">
                    07 วันที่มีผล
                    <span className="text-danger">*</span>
                  </p>

                  <p className="fw-light small">
                    {dataDetail.effective_date
                      ? moment(dataDetail.effective_date).format('DD/MM/YYYY')
                      : '-'}
                  </p>
                </ColFrom>
              </div>
            </div>
          </>
        ) : type === 'TransferOrg' ? (
          <>
            <div className="d-flex justify-content-start col-12 p-2">
              {/* Organization */}
              <div className="mb-3 row col-6">
                <div className="d-flex justify-content-start col-12">
                  <div className="col-4 ">
                    <p className="fw-bold small w-100">01 Organization</p>
                    <p className="fw-light small w-100">
                      {' '}
                      {dataDetailOld?.org ?? '-'}
                      {/* {dataDetailOld?.org_id === 1 ? (
                        <>SKY</>
                      ) : dataDetailOld?.org_id === 2 ? (
                        <>Mettheir</>
                      ) : dataDetailOld?.org_id === 3 ? (
                        <>Astro</>
                      ) : dataDetailOld?.org_id === 5 ? (
                        <>ProInside</>
                      ) : null}{' '} */}
                    </p>
                  </div>
                  <div className="d-flex justify-content-start col-2">
                    <span className=" m-4 small fw-light">to</span>
                  </div>

                  <div className="col-5 d-flex justify-content-start">
                    <p className="mt-3 fw-light small w-100 mt-4">
                      {' '}
                      {dataDetailNew?.org ?? '-'}
                    </p>
                  </div>
                </div>
              </div>
            </div>

            <div className="d-flex justify-content-start p-2 col-12">
              {/* Group */}
              <div className="mb-3 row col-6">
                <div className="d-flex justify-content-start col-12">
                  <div className="col-4 ">
                    <p className="fw-bold small w-100">02 สายงาน</p>
                    <p className="fw-light small w-100">
                      {' '}
                      {dataDetailOld?.division_en ?? '-'} (
                      {dataDetailOld?.division ?? '-'})
                      {/* {oldGroup?.label || '-'} */}
                    </p>
                  </div>
                  <div className="d-flex justify-content-start col-2">
                    <span className="d-flex justify-content-center m-4 small fw-light">
                      to
                    </span>
                  </div>

                  <div className="col-5 d-flex justify-content-start">
                    {/* <p className="fw-bold small w-100 text-white ">.</p> */}
                    <p className="mt-3 fw-light small w-100 mt-4">
                      {' '}
                      {dataDetailNew?.division_en || '-'} (
                      {dataDetailNew?.division ?? '-'})
                    </p>
                  </div>
                </div>
              </div>
              {/* Department */}
              <div className="d-flex mb-3 row col-6 ">
                <div className="d-flex justify-content-start col-12">
                  <div className="col-4 ">
                    <p className="fw-bold small w-100">03 ฝ่าย</p>
                    <p className="fw-light small w-100">
                      {' '}
                      {dataDetailOld?.department_en || '-'} (
                      {dataDetailOld?.department ?? '-'})
                    </p>
                  </div>
                  <div className="d-flex justify-content-center col-2">
                    <span className="d-flex justify-content-center m-4 small fw-light">
                      to
                    </span>
                  </div>

                  <div className="col-5 d-flex justify-content-start">
                    <p className="fw-bold small w-100 text-white">.</p>
                    <p className="mt-3 fw-light small w-100 mt-4">
                      {' '}
                      {dataDetailNew?.department_en || '-'} (
                      {dataDetailNew?.department || '-'})
                    </p>
                  </div>
                </div>
              </div>
            </div>

            <div className="d-flex justify-content-start col-12 p-2">
              {/* Department */}
              <div className="mb-3 row col-6">
                <div className="d-flex justify-content-start col-12">
                  <div className="col-4 ">
                    <p className="fw-bold small w-100">04 แผนก</p>
                    <p className="fw-light small w-100">
                      {' '}
                      {dataDetailOld?.faction_en || '-'} (
                      {dataDetailOld?.faction ?? '-'})
                    </p>
                  </div>
                  <div className="d-flex justify-content-start col-2">
                    <span className=" m-4 small fw-light">to</span>
                  </div>

                  <div className="col-5 d-flex justify-content-start">
                    {/* <p className="fw-bold small w-100 text-white ">.</p> */}
                    <p className="mt-3 fw-light small w-100 mt-4">
                      {' '}
                      {dataDetailNew?.faction_en || '-'}(
                      {dataDetailNew?.faction || '-'})
                    </p>
                  </div>
                </div>
              </div>
              {/* Team */}
              <div className="mb-3 row col-6">
                <div className="d-flex justify-content-start col-12">
                  <div className="col-4 ">
                    <p className="fw-bold small w-100">05 ทีม</p>
                    <p className="fw-light small w-100">
                      {' '}
                      {dataDetailOld?.team_en || '-'}
                    </p>
                  </div>
                  <div className="d-flex justify-content-center col-2">
                    <span className=" m-4 small fw-light">to</span>
                  </div>

                  <div className="col-5 d-flex justify-content-start">
                    <p className="fw-bold small w-100 text-white">.</p>
                    <p className="mt-3 fw-light small w-100 mt-4">
                      {' '}
                      {dataDetailNew?.team_en || '-'}
                    </p>
                  </div>
                </div>
              </div>
            </div>

            <div className="d-flex justify-content-start col-12 p-2">
              {/* Position */}
              <div className="mb-3 row col-6">
                <div className="d-flex justify-content-start col-12">
                  <div className="col-4 ">
                    <p className="fw-bold small w-100">06 ตำแหน่ง</p>
                    <p className="fw-light small w-100">
                      {' '}
                      {dataDetailOld?.position_en || '-'}
                    </p>
                  </div>
                  <div className="d-flex justify-content-start col-2">
                    <span className=" m-4 small fw-light">to</span>
                  </div>

                  <div className="col-5 d-flex justify-content-start">
                    {/* <p className="fw-bold small w-100 text-white ">.</p> */}
                    <p className="mt-3 fw-light small w-100 mt-4">
                      {' '}
                      {dataDetailNew?.position_en || '-'}
                    </p>
                  </div>
                </div>
              </div>
              {/* Level */}
              <div className="mb-3 row col-6">
                <div className="d-flex justify-content-start col-12">
                  <div className="col-4 ">
                    <p className="fw-bold small w-100">07 Level</p>
                    <p className="fw-light small w-100">
                      {oldPosition?.level_id || '-'}
                    </p>
                  </div>
                  <div className="d-flex justify-content-center col-2">
                    <span className=" m-4 small fw-light">to</span>
                  </div>

                  <div className="col-5 d-flex justify-content-start ">
                    <p className="fw-bold small w-100 text-white">.</p>
                    <p className="mt-3 fw-light small w-100  mt-4">
                      {newPosition2?.level_id || '-'}
                    </p>
                  </div>
                </div>
              </div>
            </div>

            <div className="d-flex justify-content-start col-12 p-2">
              {/* Effective Date */}
              <div className="d-flex mb-3 row col-7">
                <ColFrom>
                  <p className="mb-2 fw-bold small">
                    08 วันที่มีผล
                    <span className="text-danger">*</span>
                  </p>

                  <p className="fw-light small">
                    {moment(dataDetail.effective_date).format('DD/MM/YYYY')}
                  </p>
                </ColFrom>
              </div>
            </div>
          </>
        ) : null}
        {/* </Form> */}
      </CardCustom>
    </>
  )
}
const ColFrom = (props) => {
  const { children, className = '', ...other } = props

  return (
    <Col xl={3} xs={6} md={3} className={` ${className}`} {...other}>
      {children}
    </Col>
  )
}
